import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from 'react';
function DeadlineSettingsItemLayout(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <hr className="border-text-primary/15 mt-7 border-solid" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="flex flex-col">{children}{t1}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default DeadlineSettingsItemLayout;